import React from "react";
import {
  Paper,
  Stack,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

// Month names
const monthNames = Array.from({ length: 12 }, (_, i) =>
  new Date(0, i).toLocaleString("default", { month: "long" })
);

export default function InvoiceTableToolbar({
  statusFilter,
  setStatusFilter,
  projectFilter,
  setProjectFilter,
  projects = [],
  searchTerm,
  setSearchTerm,
  selectedMonth,
  setSelectedMonth,
  selectedYear,
  setSelectedYear,
  availableYears = [],
}) {
  // Show this year and previous 4 years if not provided
  const thisYear = new Date().getFullYear();
  const years =
    availableYears.length > 0
      ? availableYears
      : Array.from({ length: 5 }, (_, i) => thisYear - i);

  return (
    <Paper
      elevation={0}
      sx={{
        p: { xs: 1, md: 2 },
        mb: 3,
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: 2,
        background: "#f8fafc",
        boxShadow: "0 2px 12px #dae8fa12",
      }}
    >
      {/* Month Selector */}
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel>Month</InputLabel>
        <Select
          value={selectedMonth}
          label="Month"
          onChange={(e) => setSelectedMonth(Number(e.target.value))}
          sx={{ fontWeight: 600, borderRadius: 2, background: "#fff" }}
        >
          {monthNames.map((name, idx) => (
            <MenuItem key={name} value={idx + 1}>
              {name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Year Selector */}
      <FormControl size="small" sx={{ minWidth: 110 }}>
        <InputLabel>Year</InputLabel>
        <Select
          value={selectedYear}
          label="Year"
          onChange={(e) => setSelectedYear(Number(e.target.value))}
          sx={{ fontWeight: 600, borderRadius: 2, background: "#fff" }}
        >
          {years.map((yr) => (
            <MenuItem key={yr} value={yr}>
              {yr}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Status Filter */}
      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel>Status</InputLabel>
        <Select
          value={statusFilter}
          label="Status"
          onChange={(e) => setStatusFilter(e.target.value)}
          sx={{ background: "#fff", borderRadius: 2, fontWeight: 500 }}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="paid">Paid</MenuItem>
          <MenuItem value="unpaid">Unpaid</MenuItem>
        </Select>
      </FormControl>

      {/* Project Filter */}
      <FormControl size="small" sx={{ minWidth: 150 }}>
        <InputLabel>Project</InputLabel>
        <Select
          value={projectFilter}
          label="Project"
          onChange={(e) => setProjectFilter(e.target.value)}
          sx={{ background: "#fff", borderRadius: 2, fontWeight: 500 }}
        >
          <MenuItem value="">All Projects</MenuItem>
          {projects.map((proj) => (
            <MenuItem key={proj.id} value={proj.id}>
              {proj.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Search Field */}
      <TextField
        size="small"
        variant="outlined"
        placeholder="Search client, #, email…"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        sx={{
          minWidth: 200,
          flex: 1,
          background: "#fff",
          borderRadius: 2,
        }}
        InputProps={{
          style: { fontSize: 15, fontWeight: 500 },
          startAdornment: (
            <SearchIcon sx={{ color: "#7b7b7b", fontSize: 20, mr: 1, ml: 1 }} />
          ),
        }}
      />
    </Paper>
  );
}
